import React from "react";
import { Link, useLocation } from "react-router-dom";
import Dialog from "../ui/Dialog";
import NotificationCenter from "./NotificationCenter";

/** "View all notifications" from the bell: the large view in a modal (full screen on phones). */
const NotificationsModal = ({ onClose }) => {
  const inMyView = useLocation().pathname.startsWith("/me");
  return (
    <Dialog
      title="Notifications"
      subtitle={
        <Link
          to={inMyView ? "/me/notifications" : "/notifications"}
          onClick={onClose}
          className="fs-075"
        >
          Open as a page <i className="bi bi-box-arrow-up-right"></i>
        </Link>
      }
      onClose={onClose}
      size="notif"
    >
      <NotificationCenter onOpened={onClose} />
    </Dialog>
  );
};

export default NotificationsModal;
